import { SELECT_USER_ASSURANCE } from '../types/Insurance.js';



export const setUserAssurance = (userAssurance) => {
  return (dispatch) => {
    dispatch({ type: SELECT_USER_ASSURANCE, payload: userAssurance })
  };
};